export default "__VITE_ASSET__Xyys$0_x__"